<div class="bg-white p-2 rounded-md xl:max-w-2/3">
  <ul class="p-4">
    <li class="pb-3">
      <p class="text-grey-400 sm">{{ 'settings.username' | transloco }}</p>
      <p class="text-grey-800">{{ username$ | async }}</p>
    </li>
    <li>
      <p class="text-grey-400 sm">{{ 'settings.region' | transloco }}</p>
      <div class="flex justify-between">
        <span class="text-grey-800">{{ currentRegion?.name }} </span>
        <button (click)="openRegionsDialog()" class="pr-4 text-link cursor-pointer">{{ 'settings.edit' | transloco }}</button>
      </div>
    </li>
  </ul>
</div>
<div class="pt-4">
  <div class="bg-white py-7 px-4 rounded xl:max-w-2/3">
    <div class="flex flex-col items-start gap-3 md:gap-4 md:flex-row">
      <button class="text-grey-500 cursor-pointer" (click)="openTermsAndConditionsDialog()">
        <p class="sm inline underline pr-2">{{ 'settings.termsAndConditions' | transloco }}</p>
        <i class="pi pi-external-link" style="font-size: 0.8rem;"></i>
      </button>
      <a class="text-grey-500 block" href="https://www.jcb.com/en-GB/explore/corporate/cookie-and-privacy-policy/" target="_blank">
        <span class="inline-block underline pr-2">{{ 'settings.privacyPolicy' | transloco }}</span>
        <i class="pi pi-external-link" style="font-size: 0.8rem;"></i>
      </a>
    </div>
  </div>
</div>
